export default __webpack_public_path__ + "static/media/Me and my Pet .64d3a2aa.mp4";